import Header from "@/components/header/Header.vue";
//import { MenuOptions } from '@/components/Menu/menu-options';
import MenuRoot from "@/components/Menu/menu-root.vue";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import CSSModule from "@/store/modules/css-module";
import "material-design-icons/iconfont/material-icons.css";
import CargaDialog from "@/views/cargando/CargaDialog.vue";
import menu_optionModule from "@/store/modules/menu_option-module";
import usuarioModule from "@/store/modules/usuario-module";
import OnboardingAIChat from "@/components/Assistant/OnboardingAIChat.vue";
@Component({
  components: {
    MenuRoot,
    Header,
    CargaDialog,
    OnboardingAIChat,
  },
})
export default class MainLayout extends Vue {
  //public fullMenuOptions = MenuOptions;
  public appTitle = process.env.VUE_APP_TITLE;
  public route: any;

  public constructor() {
    super();
    this.bodystyle();
    Vue.prototype.$heightsection = this.$vuetify.breakpoint.height - 110;
  }
  public async created() {
    await usuarioModule.getusuariosPermiso();
    menu_optionModule.getmenu();
    this.$root.$on("ai:navigate", (routeName: string) => {
      const bestRoute = this.findBestRoute(routeName);
      if (bestRoute) {
        this.$router.push({ name: bestRoute }).catch(() => {
          console.warn(`AI navigation failed for: ${bestRoute}`);
        });
      }
    });
  }

  public beforeDestroy() {
    this.$root.$off("ai:navigate");
  }

  private findBestRoute(target: string): string | null {
    // 1. Intentar coincidencia directa por nombre de ruta (técnico)
    const routes = (this.$router as any).getRoutes
      ? (this.$router as any).getRoutes()
      : (this.$router as any).options.routes || [];

    const routeNames: string[] = routes
      .map((r: any) => r.name)
      .filter((n: string) => !!n);

    // Exacto o Insensible a mayúsculas
    const foundCI = routeNames.find(
      (n: string) => n.toLowerCase() === target.toLowerCase()
    );
    if (foundCI) return foundCI;

    // 2. Intentar coincidencia por TEXTO DEL MENÚ (humano)
    const flatMenu = this.flattenMenu(menu_optionModule.menu_options_menu);
    let bestMenuMatch = null;
    let highestMenuScore = 0;

    for (const item of flatMenu) {
      const score = this.calculateSimilarity(
        target.toLowerCase(),
        item.text.toLowerCase()
      );
      if (score > highestMenuScore) {
        highestMenuScore = score;
        bestMenuMatch = item;
      }
    }

    // Si hay una coincidencia fuerte en el menú (>60%), resolvemos su link a un nombre de ruta
    if (bestMenuMatch && highestMenuScore > 0.6) {
      const resolved = this.$router.resolve(bestMenuMatch.link);
      if (resolved && resolved.route && resolved.route.name) {
        return resolved.route.name;
      }
    }

    // 3. Fallback: Búsqueda difusa en nombres técnicos de ruta
    let bestRouteMatch = null;
    let highestRouteScore = 0;

    for (const name of routeNames) {
      const score = this.calculateSimilarity(
        target.toLowerCase(),
        name.toLowerCase()
      );
      if (score > highestRouteScore) {
        highestRouteScore = score;
        bestRouteMatch = name;
      }
    }

    return highestRouteScore > 0.4 ? bestRouteMatch : null;
  }

  private flattenMenu(items: any[]): Array<{ text: string; link: string }> {
    let result: Array<{ text: string; link: string }> = [];
    for (const item of items) {
      if (item.link && item.link !== "#") {
        result.push({ text: item.text, link: item.link });
      }
      if (item.children && item.children.length > 0) {
        result = result.concat(this.flattenMenu(item.children));
      }
    }
    return result;
  }

  private calculateSimilarity(s1: string, s2: string): number {
    let longer = s1;
    let shorter = s2;
    if (s1.length < s2.length) {
      longer = s2;
      shorter = s1;
    }
    const longerLength = longer.length;
    if (longerLength === 0) return 1.0;
    return (
      (longerLength - this.editDistance(longer, shorter)) /
      parseFloat(longerLength.toString())
    );
  }

  private editDistance(s1: string, s2: string): number {
    const costs = [];
    for (let i = 0; i <= s1.length; i++) {
      let lastValue = i;
      for (let j = 0; j <= s2.length; j++) {
        if (i === 0) costs[j] = j;
        else {
          if (j > 0) {
            let newValue = costs[j - 1];
            if (s1.charAt(i - 1) !== s2.charAt(j - 1))
              newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
            costs[j - 1] = lastValue;
            lastValue = newValue;
          }
        }
      }
      if (i > 0) costs[s2.length] = lastValue;
    }
    return costs[s2.length];
  }
  public get aiAssistantEnabled(): boolean {
    return (process.env.VUE_APP_AI_ASSISTANT_ENABLED as string) === "true";
  }

  public get fullMenuOptions() {
    return menu_optionModule.menu_options_menu;
  }
  public get animation_type() {
    this.route = this.$route;
    let animations = ["fade", "slide-fade", "bounce"];
    return animations[Math.floor(Math.random() * 3)];
  }
  public async bodystyle() {
    if ((process.env.VUE_APP_PRODUCTION as string) === "true") {
      if (this.$vuetify.breakpoint.smAndDown) {
        document.body.style.paddingRight = "0px";
      } else {
        document.body.style.overflowX = "visible";
        document.body.style.paddingRight = "0px";
      }
    }
    if (!CSSModule.cssimportados) {
      var files: string[] = [];
      files.push(
        "https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css"
      );
      for (let i = 0; i < files.length; i++) {
        /* const element = files[i];
         var styles = "@import url('" + files[i] + "');";*/
        var newSS = document.createElement("link");
        newSS.rel = "stylesheet";
        newSS.href = files[i]; //'data:text/css,' + escape(styles);
        document.getElementsByTagName("head")[0].appendChild(newSS);
      }

      CSSModule.css_importados();
    }
  }
}
